import { useRef } from 'react';
import styles from './RevealShowcase.module.css';
import useRevealShowcase from '../hooks/useRevealShowcase.js';

/**
 * ═══ REVEAL SHOWCASE (스크롤 캐릭터 시퀀스 → 로고) ═══
 * 긴 스크롤 구간(.revealScroll) 안에서 .revealSticky가 핀 고정되고, 스크롤 진행률에 맞춰
 * 프레임 이미지(/assets/seq_run/f00~f59.webp)를 <img>.src로 갈아끼운다:
 * 흰화면 → 캐릭터가 달려 지나감 → 흰화면 → 로고 "두둥 팍!". 초기 src=f59(흰 프레임).
 * 동작·타이밍 전체는 hooks/useRevealShowcase.js 주석 참고.
 */
export default function RevealShowcase() {
  const scrollRef = useRef(null);
  const stageRef = useRef(null);
  const panelRef = useRef(null);
  const logoRef = useRef(null);
  const frameRef = useRef(null);

  useRevealShowcase(scrollRef, stageRef, panelRef, logoRef, frameRef);

  return (
    <section ref={scrollRef} className={styles.revealScroll} aria-label="잉글리시팝 브랜드 월드">
      <div className={styles.revealSticky}>
        <div ref={panelRef} className={styles.revealPanel}>
          <div ref={stageRef} className={styles.revealStage}>
            <img ref={frameRef} className={styles.revealFrame} src="/assets/seq_run/f59.webp" alt="" aria-hidden="true" />
          </div>
        </div>
        {/* 로고는 패널 밖(스티키 직속)으로 빼서 overflow에 안 잘리고 크게/팝 가능 */}
        <span ref={logoRef} className={styles.revealLogo}>
          <img src="/assets/logo_en_cut.png" alt="English POP" />
        </span>
      </div>
    </section>
  );
}
